import { useEffectivePlatform } from './useEffectivePlatform';

export const useMobileView = (): boolean => useEffectivePlatform() === 'mobile';
